import React from 'react';
import {ChartCard, ChartHeader, ChartSubtitle, ChartTitle,} from './styles';
import {useDashboardContext} from "../../../Dashboard";
import {Alert, CircularProgress, Link, Stack, Typography} from "@mui/material";
import {NoOneGroup} from "../VkConnectCard/VkConnectCard";
import {Tabs} from "../../Tabs";
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DateRangeIcon from '@mui/icons-material/DateRange';

const PostsItem = ({name, posts}) => {
    if (!posts?.length) return <Alert color={"error"}>Еще нет ни одного поста для <b>{name}</b></Alert>

    return (
        <>
            {posts.map((post) => (
                <Stack key={post.id} sx={{gap: 1}}>
                    <Stack direction={"row"} sx={{gap: 1, justifyContent: "space-between", alignItems: "center", opacity: post?.url ? 1 : 0.3}}>
                        <Stack direction={"row"} sx={{gap: 1, alignItems: "center"}}>
                            {post?.url ? (
                                <>
                                    <CheckCircleIcon color={"success"}/>
                                    <Link rel={"nofollow noreferrer noopener"} target={"_blank"} href={post?.url}>
                                        <Typography variant={"caption"} sx={{alignItems: "center"}}>
                                            {post.title}
                                        </Typography>
                                    </Link>
                                </>
                            ) : (
                                <>
                                    <AccessAlarmsIcon/>
                                    <Typography variant={"caption"} sx={{alignItems: "center"}}>
                                        {post.title}
                                    </Typography>
                                </>
                            )}
                        </Stack>

                        <Typography variant={"caption"}>
                            {!post?.date ? <DateRangeIcon/> : new Date(post?.date).toLocaleDateString("ru")}
                        </Typography>
                    </Stack>
                    <hr/>
                </Stack>
            ))}
        </>
    )
}

const Posts = ({onConnect}) => {
    const {groups, groupsError} = useDashboardContext();

    if (groupsError) return <Alert color={"error"}>Ошибка: не удалось загрузить посты</Alert>
    if (!groups) return <CircularProgress/>
    if (!groups.filter(group => group.joined).length) return <NoOneGroup onConnect={onConnect}/>


    const items = groups.filter(group => group.joined).map(({name, posts}) => ({
        name,
        body: <PostsItem name={name} posts={posts}/>
    }));

    return (
        <Tabs key={new Date()} items={items}/>
    )
}

export default function VkPosts({onConnect}) {
    const {POSTS_DATA} = useDashboardContext();

    return (
        <ChartCard>
            <ChartHeader>
                <Stack sx={{gap: 0.5}}>
                    <ChartTitle>{POSTS_DATA.title}</ChartTitle>
                    <ChartSubtitle>{POSTS_DATA.subtitle}</ChartSubtitle>
                </Stack>
            </ChartHeader>
            <Posts onConnect={onConnect}/>
        </ChartCard>
    );
}
